import { ICurrencyConfig } from '../models/currency.model'

export const CURRENCY_CONFIG: ICurrencyConfig = {
    INR: {
        currency: 'INR',
        locale: 'en-IN',
        symbol: '₹',
        position: 'before',
        decimalPlaces: 2,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        showSymbol: true,
    },
    USD: {
        currency: 'USD',
        locale: 'en-US',
        symbol: '$',
        position: 'before',
        decimalPlaces: 2,
        showSymbol: true,
    },
    EUR: {
        currency: 'EUR',
        locale: 'en-EU',
        symbol: '€',
        position: 'before',
        decimalPlaces: 2,
        showSymbol: true,
    },
    GBP: {
        currency: 'GBP',
        locale: 'en-GB',
        symbol: '£',
        position: 'before',
        decimalPlaces: 2,
        showSymbol: true,
    },
    AUD: {
        currency: 'AUD',
        locale: 'en-AU',
        symbol: 'A$',
        position: 'before',
        decimalPlaces: 2,
        showSymbol: true,
    },
    CAD: {
        currency: 'CAD',
        locale: 'en-CA',
        symbol: 'C$',
        position: 'before',
        decimalPlaces: 2,
        showSymbol: true,
    },
}
